export default {"src":"/_next/static/media/javascript_logo_f4b1c569e7.e5dde44e.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};